import { render, staticRenderFns } from "./photo-swipper.vue?vue&type=template&id=f5022014&scoped=true&"
import script from "./photo-swipper.vue?vue&type=script&lang=js&"
export * from "./photo-swipper.vue?vue&type=script&lang=js&"
import style0 from "./photo-swipper.vue?vue&type=style&index=0&id=f5022014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5022014",
  null
  
)

export default component.exports